exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trial-user {\n  color: gray;\n}\n.app-header.navbar .navbar-brand svg {\n  width: 221px;\n}\n.app-header.navbar {\n  padding-left: 0;\n}\n.header-fixed::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 0px;\n}\n.custom-logo {\n  object-fit: fit;\n}\n@-moz-document url-prefix() {\n  /* Disable scrollbar Firefox */\nhtml {\n    scrollbar-width: none;\n}\n}\nbody {\n  margin: 0;\n  /* remove default margin */\n  scrollbar-width: none;\n  /* Also needed to disable scrollbar Firefox */\n  -ms-overflow-style: none;\n  /* Disable scrollbar IE 10+ */\n  overflow-y: scroll;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-741978ef","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header/Header.vue
// module id = 944
// module chunks = 2